export default __webpack_public_path__ + "static/Android-Apple-Watch-a317ce119e3ec59bfe9c54fa16b7a905.webp";